import React, { useEffect, useState } from "react";
import { AiFillBackward } from "react-icons/ai";
import { CiCircleRemove } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { toast } from "react-toastify";
import { useGetDealersQuery } from "../../features/api/dealerApi";
import { useGetCategoryQuery } from "../../features/api/categoryApi";
import {
  useAddInvoiceMutation,
  useGetInvoicesQuery,
} from "../../features/api/orderinvoiceApi";
import {
  useAddReturnMutation,
  useGetReturnsQuery,
} from "../../features/api/returnApi";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { useAddReturnlistMutation } from "../../features/api/returnlistApi";
import { useGetSalesListQuery } from "../../features/api/saleslistApi";
import { useGetProductQuery } from "../../features/api/productApi";
import { useAddTransactionMutation } from "../../features/api/transactionApi";
import { API_BASE_URL } from "../../components/baseUrl";

const ReturnCreate = () => {
  // fetch all dealer
  const { data: delr } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = delr?.dealer;

  // fetch all categories
  const { data: cat } = useGetCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const categories = cat?.categories;

  const {
    data: inv,
    error,
    isLoading,
  } = useGetInvoicesQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const orders2 = inv?.orders_twos;

  const { data } = useGetReturnsQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const returns2 = data?.returnTwo;

  let maxInvNo = 0;

  returns2?.map((data) => {
    const chalanNo = data?.return_no;
    const chalanSeperate = chalanNo?.split("-")[1];
    const generateAgain = chalanSeperate?.split("/")[0];
    if (!isNaN(generateAgain) && +generateAgain > +maxInvNo) {
      maxInvNo = generateAgain;
    }
  });
  const generateInvoice = `RE-${+maxInvNo + 1}/23`;

  // filter dealer previous dues
  const [dealer, setDealerName] = useState("");
  const [return_inv, setReturnInvoice] = useState(null);

  // console.log(orders2)

  const findInvoiceByDealer = orders2?.filter(
    (order2) => order2?.dealer === +dealer
  );

  const { data: pro } = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const products = pro?.products;

  // const [ch_no, setChNo] = useState(purchases?.length + 1);
  const [inv_date, setInvDate] = useState(new Date());
  const [cat_name, setCategory] = useState("");
  const [sub_catName, setSubCategory] = useState("");
  const [pro_name, setProduct] = useState("");
  const encodedProductName = encodeURIComponent(pro_name);
  const apiUrl = `${API_BASE_URL}/api/salesRatebyproname?proName=${encodedProductName}`;

  // fetch Brand by category name
  const [subCatByCat, setSubCatByCat] = useState([]);
  const [relode, setRelode] = useState(false);
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/sub-categories/${cat_name}`)
      .then((res) => res.json())
      .then((data) => {
        setSubCatByCat(data?.subCategory);
        setRelode(!relode);
      });
  }, [cat_name]);

  // fetch product by Brand name
  const [getProductBySubCat, setGetProductBySubCat] = useState([]);
  // console.log(getProductBySubCat)
  useEffect(() => {
    fetch(
      `${API_BASE_URL}/api/subCatProducts?subCategory=${sub_catName}`
    )
      .then((res) => res.json())
      .then((data) => {
        setGetProductBySubCat(data?.product);
        setRelode(!relode);
      });
  }, [sub_catName]);

  // fetch product by Brand name
  const [getProductByProName, setGetProductByProName] = useState({});
  useEffect(() => {
    fetch(apiUrl)
      .then((res) => res.json())
      .then((data) => {
        setGetProductByProName(data?.product);
        setRelode(!relode);
      });
  }, [pro_name]);

  // for save multiple purchase data
  const [newArray, setNewArray] = useState([]);
  const handleAddItem = () => {
    const isProductExists = newArray?.some(
      (item) => item?.pro_name === getProductByProName?.pro_name
    );

    if (!isProductExists) {
      setNewArray([
        ...newArray,
        {
          return_no: generateInvoice,
          return_date: inv_date,
          return_inv: return_inv,
          sub_cat: sub_catName,
          pro_name: pro_name,
          qty: 1,
          sales_rate: 0,
        },
      ]);
    }
  };

  // handle quantity for individual product
  const handlePriceChange = (index, price) => {
    const updatedData = [...newArray];
    updatedData[index].sales_rate = price;
    updatedData[index].total = price * updatedData[index].qty;
    setNewArray(updatedData);
  };

  const handleQuantityChange = (index, qty) => {
    const updatedData = [...newArray];
    updatedData[index].qty = qty;
    updatedData[index].total = qty * updatedData[index].sales_rate;
    setNewArray(updatedData);
  };

  const subTotal = newArray?.reduce((sum, item) => sum + item.total, 0);

  // remove from product list before purchase
  const handleRemove = (index) => {
    const restProduct = [...newArray];
    restProduct.splice(index, 1);
    setNewArray(restProduct);
  };

  const navigate = useNavigate();
  // handle function for purchase product

  const [isActive, setIsActive] = useState(true);
  const [createReturnList] = useAddReturnlistMutation();
  const [crataNewReturn] = useAddReturnMutation();
  const [addNewTransaction] = useAddTransactionMutation();

  const handleReturn = async () => {
    setIsActive(false);
    const data2 = {
      return_no: generateInvoice,
      return_date: inv_date,
      return_inv: return_inv,
      dealer: dealer,
      total: subTotal,
    };
    const transactionReturn = {
      ledger_id: 1,
      tag_ac_id: dealer,
      invoice_id: generateInvoice,
      description: `Sales Return Value ${generateInvoice}`,
      credit_amount: subTotal,
      trDate: inv_date,
    };

    try {
      const response = await createReturnList(newArray);
      const result = await crataNewReturn(data2);
      await addNewTransaction(transactionReturn);

      if (response) {
        navigate("/dashboard/returnProduct");
        // toast.success('success')
      }
    } catch (error) {
      console.error("Error create data:", error?.response);
    }
  };

  return (
    <div className="h-[90vh] overflow-auto">
      <div className="flex justify-between items-center p-4">
        <h1 className="text-xl font-bold">Create Return</h1>
        <div className="flex items-center gap-x-2">
          <Link
            to="/dashboard/returnProduct"
            className="bg-blue-500 px-2 py-1 rounded text-white flex items-center gap-x-1"
          >
            <AiFillBackward /> Return List{" "}
          </Link>
        </div>
      </div>
      <div className="">
        <div className="p-4 m-4 border">
          <form className=" grid grid-cols-2 lg:grid-cols-3 lg:gap-6">
            <div className="flex flex-col gap-1 ">
              <label>Return No.</label>
              <input
                type="text"
                value={generateInvoice}
                disabled
                className="border h-8 pl-1"
              />
            </div>
            <div className="flex flex-col gap-1 ">
              <label>Return Date</label>
              <DateTimePicker
                value={inv_date}
                onChange={setInvDate}
                className=" h-8"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Dealer Name</label>
              <select
                onChange={(e) => setDealerName(e.target.value)}
                className="border h-8 p-1"
              >
                <option>--select--</option>
                {dealers?.map((dealer) => (
                  <option key={dealer?.id} value={dealer?.id} className="">
                    {dealer?.d_name} - {dealer?.d_mobile}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label>Return Invoice</label>
              <select
                onChange={(e) => setReturnInvoice(e.target.value)}
                className="border h-8 p-1"
              >
                <option>--select--</option>
                {findInvoiceByDealer?.map((invoice) => (
                  <option
                    key={invoice?.id}
                    value={invoice?.inv_no}
                    className=""
                  >
                    {invoice?.inv_no}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label>Category</label>
              <select
                onChange={(e) => setCategory(e.target.value)}
                className="border h-8 pl-1"
              >
                <option>--select--</option>
                {categories?.map((category) => (
                  <option key={category?.id} value={category?.id}>
                    {category?.cat_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label>Brand</label>
              <select
                onChange={(e) => setSubCategory(e.target.value)}
                className="border h-8 pl-1"
              >
                <option>--select--</option>
                {subCatByCat?.map((sCat) => (
                  <option key={sCat?.id} value={sCat?.id}>
                    {sCat?.sub_catName}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label>Product / Model</label>
              <select
                onChange={(e) => setProduct(e.target.value)}
                className="border h-8 pl-1"
              >
                <option>--select--</option>
                {getProductBySubCat?.map((product) => (
                  <option key={product?.id} value={product?.id}>
                    {product?.product_name}
                  </option>
                ))}
              </select>
            </div>
          </form>
          <button
            onClick={() => handleAddItem()}
            className="bg-blue-500 px-4 py-1 text-white font-bold block mx-auto mt-4"
          >
            Add Product
          </button>
        </div>
        <div className="p-4 m-4 border ">
          <table className="min-w-full bg-white ">
            <thead>
              <tr>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Product Name
                </th>

                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Sales Rate
                </th>

                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Quantity
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Total Amount
                </th>
                <th className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {newArray?.map((data, index) => {
                const proName = products?.find(
                  (pro) => pro?.id === +data?.pro_name
                );
                return (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {proName?.product_name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <input
                        type="number"
                        onChange={(e) =>
                          handlePriceChange(index, e.target.value)
                        }
                        className="w-20 border focus:outline-none"
                      />
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <input
                        onChange={(e) =>
                          handleQuantityChange(index, e.target.value)
                        }
                        type="number"
                        defaultValue={data?.qty}
                        className="border pl-1 w-20 focus:outline-none"
                      />
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      {data?.total}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap border-b border-gray-300">
                      <button
                        onClick={() => handleRemove(index)}
                        className="text-xl text-white bg-red-500 rounded-full"
                      >
                        <CiCircleRemove />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <thead>
              <tr className="">
                <th
                  colSpan={3}
                  className="px-6 py-3 border-b-2 font-bold border-gray-300 text-right  uppercase tracking-wider"
                >
                  Sub-Total:
                </th>
                <th
                  colSpan={2}
                  className="px-6 py-3 border-b-2  border-gray-300 text-left  font-bold uppercase tracking-wider"
                >
                  {subTotal}
                </th>
              </tr>
              {/* <tr className="">
                <th
                  colSpan={3}
                  className="px-6 py-3 border-b-2 font-bold border-gray-300 text-right text-xs uppercase tracking-wider"
                >
                  previous due:
                </th>
                <th
                  colSpan={2}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider"
                >
                  {balance}
                </th>
              </tr> */}
              {/* <tr className="hidden">
                <th
                  colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-right text-xs font-semibold uppercase tracking-wider"
                >
                  VAT(%):{" "}
                  <input
                    onChange={(e) => setVat(e.target.value)}
                    type="number"
                    defaultValue={vat}
                    className="border p-1 w-12"
                  />
                </th>
                <th
                  colSpan={2}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider"
                >
                  {vatAmount}
                </th>
              </tr> */}
              {/* <tr className="hidden">
                <th
                  colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-right text-xs font-semibold uppercase tracking-wider"
                >
                  Total:
                </th>
                <th
                  colSpan={2}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider"
                >
                  {totalAmounts}
                </th>
              </tr> */}
              {/* <tr className="hidden">
                <th
                  colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-right text-xs font-semibold uppercase tracking-wider"
                >
                  Discount:
                </th>
                <th
                  colSpan={2}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider"
                >
                  <input
                    onChange={(e) => setDiscount(e.target.value)}
                    type="number"
                    defaultValue={discount}
                    className="border p-1 w-16"
                  />
                </th>
              </tr> */}
              {/* <tr>
                <th
                  colSpan={3}
                  className="px-6 py-3 border-b-2 font-bold border-gray-300 text-right text-xs uppercase tracking-wider"
                >
                  Grand-Total:
                </th>
                <th
                  colSpan={2}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-bold uppercase tracking-wider"
                >
                  {grandTotal}
                </th>
              </tr> */}
              {/* <tr>
                <th
                  colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-right text-xs font-semibold uppercase tracking-wider"
                >
                  Paid:
                </th>
                <th
                  colSpan={2}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider"
                >
                  <input
                    onChange={(e) => setPaid(e.target.value)}
                    type="number"
                    defaultValue={paid}
                    className="border p-1 w-16"
                  />
                </th>
              </tr> */}
              {/* <tr>
                <th
                  colSpan={3}
                  className="px-6 py-3 border-b-2 border-gray-300 text-right text-xs font-semibold uppercase tracking-wider"
                >
                  Due:
                </th>
                <th
                  colSpan={2}
                  className="px-6 py-3 border-b-2 border-gray-300 text-left text-xs font-semibold uppercase tracking-wider"
                >
                  {duesForSee}
                </th>
              </tr> */}
            </thead>
          </table>
          <button
            onClick={() => handleReturn()}
            disabled={isActive === false}
            className={`bg-green-500 px-4 py-1 text-white font-bold  mt-4 ${
              isActive === false ? "cursor-not-allowed" : ""
            }`}
          >
            Submit
            {/* <Link to="/dashboard/order/invoice" state={passData}>Submit</Link> */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReturnCreate;
